import Swal from 'sweetalert2';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  FormControl,
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
} from '@angular/forms';
import { CorrespondenceTeamDto } from '@cradua/data';

@Component({
  selector: 'mrsoftapps-team-view',
  templateUrl: './team-view.component.html',
  styleUrls: ['./team-view.component.css'],
})
export class TeamViewComponent implements OnInit {
  @Input() teams: CorrespondenceTeamDto[];
  teamForm: FormGroup;
  control = new FormControl();
  @Output() changeEmit = new EventEmitter<CorrespondenceTeamDto>();
  @Output() deleteEvent = new EventEmitter<any>();

  filteredDelete: Array<any> = [];
  loading = true;
  status: boolean;
  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.teamForm = this.fb.group({ Teams: this.fb.array([]) });
    this.setTeam();
  }

  // method to display countries
  setTeam() {
    const control = this.teamForm.controls.Teams as FormArray;
    this.teams.forEach((e) => {
      control.push(
        this.fb.group({
          CorrespondenceTeamName: e.CorrespondenceTeamName,
          id: e.id,
        })
      );
    });
  }

  // method to reset form array after selection
  clearFormArray = (formArray: FormArray) => {
    const control = this.teamForm.controls.Teams as FormArray;
    while (formArray.length !== 0) {
      control.removeAt(0);
    }
  };

  // method to add Country
  addTeam() {
    const control = this.teamForm.controls.Teams as FormArray;
    control.insert(
      0,
      this.fb.group({
        CorrespondenceTeamName: ['', Validators.required],
        id: null,
      })
    );
  }

  print(event: any) {
    window.print();
  }
  // method to delete country from arrary list
  deleteTeam(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.teamForm.controls.Teams as FormArray;
        control.removeAt(index);

        if (value.id != null && value.id !== '') {
          this.filteredDelete.push(value.id);
        }

        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  onSubmit(formValue: any) {
    formValue.type = 'team';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.filteredDelete.unshift('team');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }
}
